import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import SpotlightInner from './spotlight-inner';
import { SpotlightConsumer } from './spotlight-manager';

/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */
const Spotlight = ({
  dialogWidth = 400,
  pulse = true,
  testId = 'spotlight',
  targetNode,
  target,
  ...rest
}) => /*#__PURE__*/React.createElement(SpotlightConsumer, null, ({
  opened,
  closed,
  targets
}) => {
  // use the targetNode prop or try get the target from context targets using name
  const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
  return actualTargetNode ? /*#__PURE__*/React.createElement(SpotlightInner, _extends({}, rest, {
    targetNode: actualTargetNode,
    target: target,
    onOpened: opened,
    onClosed: closed,
    testId: testId,
    dialogWidth: dialogWidth,
    pulse: pulse
  })) : null;
});
export default Spotlight;